import React, { useEffect, useState } from "react";
import { List, Modal, Skeleton } from "antd";
import { useLazyGetWorkOrderAssetsQuery } from "../../../../../../store/services/api/work-order-api";

interface WorkOrdersListAssetModalProps {
  workOrderId: string;
  triggerContent: React.ReactNode;
}

export default function WorkOrdersListAssetModal({
  workOrderId,
  triggerContent,
}: WorkOrdersListAssetModalProps) {
  const [open, setOpen] = useState(false);
  const [getWorkOrderAssets, { data, isFetching }] =
    useLazyGetWorkOrderAssetsQuery();

 
  useEffect(() => {
    if (open) {
      getWorkOrderAssets({ workOrderId, showChecked: true, pageNumber: 1, pageSize: 100000 });
    }
  }, [open, workOrderId, getWorkOrderAssets]);

  return (
    <>
      {/* This shows inside the table cell */}
      <span
        onClick={() => setOpen(true)}
        style={{ cursor: "pointer", color: "#1677ff" }}
      >
        {triggerContent}
      </span>

      <Modal
        centered
        title="Assets"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      >
        <Skeleton loading={isFetching} active>
          {/* Table header */}
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 1 }}>Asset Code</div>
            <div style={{ flex: 2 }}>Description</div>
          </div>

          {/* List as rows */}
          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data?.list || []}
            renderItem={(item) => (
              <List.Item key={item.assetCode} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 1 }}>{item.assetCode}</div>
                <div style={{ flex: 2 }}>{item.assetDescription}</div>
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
